import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

// ===== SLIDER DE RECOMMANDATIONS  =====
(function() {
  let currentIndex = 0;
  let totalItems = 0;
  let isAnimating = false;
  
  function initSlider() {
    const track = document.querySelector('.slider-track');
    const prevBtn = document.querySelector('.slider-arrow-prev');
    const nextBtn = document.querySelector('.slider-arrow-next');
    const items = document.querySelectorAll('.slider-item');
    const dotsContainer = document.querySelector('.slider-dots');
    
    if (!track || !prevBtn || !nextBtn || items.length === 0) return;
    
    totalItems = items.length;
    currentIndex = 0;
    
    // Créer les dots
    dotsContainer.innerHTML = '';
    for (let i = 0; i < totalItems; i++) {
      const dot = document.createElement('button');
      dot.className = 'slider-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', `Aller au produit ${i + 1}`);
      dot.addEventListener('click', () => goToSlide(i));
      dotsContainer.appendChild(dot);
    }
    
    // Fonction pour aller à un slide spécifique
    function goToSlide(index) {
      if (isAnimating || index === currentIndex) return;
      
      isAnimating = true;
      currentIndex = Math.max(0, Math.min(index, totalItems - 1));
      
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
      
      // Mettre à jour les boutons
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex === totalItems - 1;
      
      // Mettre à jour les dots
      document.querySelectorAll('.slider-dot').forEach((dot, i) => {
        dot.classList.toggle('active', i === currentIndex);
      });
      
      setTimeout(() => {
        isAnimating = false;
      }, 400);
    }
    
    // Navigation
    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
        goToSlide(currentIndex - 1);
      }
    });
    
    nextBtn.addEventListener('click', () => {
      if (currentIndex < totalItems - 1) {
        goToSlide(currentIndex + 1);
      }
    });
    
    // Support clavier
    document.addEventListener('keydown', (e) => {
      const sliderVisible = document.querySelector('.cart-drawer__recommendations-slider');
      if (!sliderVisible) return;
      
      if (e.key === 'ArrowLeft') {
        prevBtn.click();
      } else if (e.key === 'ArrowRight') {
        nextBtn.click();
      }
    });
    
    // Gestion de l'ajout au panier SANS fermer le drawer
    const addButtons = document.querySelectorAll('.slider-add-btn[data-variant-id]');
    addButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const btn = this;
        const variantId = btn.dataset.variantId;
        const originalHTML = btn.innerHTML;

        btn.classList.add('loading');
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId), quantity: 1 }]
          })
        })
        .then(response => response.json())
        .then(() => {
          btn.classList.remove('loading');
          btn.classList.add('success');

          // Rafraîchir le contenu du panier via Section Rendering API
          const sectionId = document.querySelector('cart-items-component')?.dataset.sectionId;
          if (sectionId) {
            fetch(`${window.location.pathname}?sections=${sectionId}`)
              .then(r => r.json())
              .then(sections => {
                const html = sections[sectionId];
                if (html) {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');

                  // Mettre à jour les produits du panier
                  const newProducts = doc.querySelector('.cart-drawer__items');
                  const currentProducts = document.querySelector('.cart-drawer__items');
                  if (newProducts && currentProducts) {
                    currentProducts.innerHTML = newProducts.innerHTML;
                  }

                  // Mettre à jour le résumé (total)
                  const newSummary = doc.querySelector('.cart-drawer__summary');
                  const currentSummary = document.querySelector('.cart-drawer__summary');
                  if (newSummary && currentSummary) {
                    currentSummary.innerHTML = newSummary.innerHTML;
                  }

                  // Mettre à jour le header du panier (compteur)
                  const newHeader = doc.querySelector('#cart-drawer-header');
                  const currentHeader = document.querySelector('#cart-drawer-header');
                  if (newHeader && currentHeader) {
                    currentHeader.innerHTML = newHeader.innerHTML;
                  }

                  // Mettre à jour le cart bubble dans le header du site
                  const newBubble = doc.querySelector('cart-bubble');
                  const currentBubble = document.querySelector('cart-bubble');
                  if (newBubble && currentBubble) {
                    currentBubble.replaceWith(newBubble);
                  }
                }
              });
          }

          setTimeout(() => {
            btn.classList.remove('success');
            btn.disabled = false;
            btn.innerHTML = originalHTML;
          }, 1000);
        })
        .catch(error => {
          console.error('Erreur lors de l\'ajout au panier:', error);
          btn.classList.remove('loading');
          btn.disabled = false;
        });
      });
    });
    
    // Initialiser l'état des boutons
    goToSlide(0);
  }
  
  // Initialiser au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlider);
  } else {
    initSlider();
  }
  
  // Réinitialiser quand le cart drawer s'ouvre/se met à jour
  const observer = new MutationObserver(function(mutations) {
    let shouldReinit = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (node.classList && (
            node.classList.contains('cart-drawer__recommendations-slider') ||
            (node.querySelector && node.querySelector('.cart-drawer__recommendations-slider'))
          )) {
            shouldReinit = true;
          }
        });
      }
    });
    if (shouldReinit) {
      setTimeout(initSlider, 100);
    }
  });
  
  const cartDrawer = document.querySelector('cart-drawer-component');
  if (cartDrawer) {
    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }
})();